import { render, staticRenderFns } from "./SmsDetail.vue?vue&type=template&id=2e516130&scoped=true&"
import script from "./SmsDetail.vue?vue&type=script&lang=js&"
export * from "./SmsDetail.vue?vue&type=script&lang=js&"
import style0 from "./SmsDetail.vue?vue&type=style&index=0&id=2e516130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e516130",
  null
  
)

export default component.exports